import React from 'react';
import GetBrowserInfo from './helpers/GetBrowserInfo';

export default function ItemCard({item , setItem}: any) {
  
  const browserInfo: any = GetBrowserInfo();

  const handleMouseOver = () => {
    const desplazamientoX = Math.random() > 0.5 ? 70 : 30;
    const desplazamientoY = Math.random() > 0.5 ? 70 : 30;
    let imagebox = document.querySelector<HTMLElement>('.item-card-container:hover')
    if (imagebox != null) {
      imagebox.style.setProperty('--position-y', desplazamientoY + '%')
      imagebox.style.setProperty('--position-x', desplazamientoX + '%')
    }
  };

  return (
    <div className={`item-card-container ${item.interactable ? '' : 'disabled'}`} onMouseOver={handleMouseOver} style={{ backgroundImage: `url(${browserInfo.isOSiOS === true ? item.icon : item.background})` }} >
      <div className="item-card-title-container">
        <div className="item-card-title-text">{item.name}</div>
        <div className="item-card-title-button" onClick={() => setItem(item)}>
          <i className="fa-solid fa-xl fa-chevron-right item-card-title-button-arrow" style={{ color: `#294B64`}} />
        </div>
      </div>
    </div>
  );
}
